import { ButtonProps, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { BugReport } from './BugReport'
import { MouseEvent } from 'react'
import useDialog from '../hooks/useDialog'

type BugReportButtonProps = Omit<ButtonProps, 'children'>

export default function BugReportButton({ onClick, ...props }: BugReportButtonProps) {
  /**
   * The translation function
   */
  const { t } = useTranslation('common')

  /**
   * The dialog state.
   */
  const { open, openDialog, closeDialog } = useDialog()

  /**
   * Handle the click event.
   */
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    openDialog()

    if (onClick) {
      onClick(event)
    }
  }

  return (
    <>
      <Button {...props} onClick={handleClick}>
        {t('Navbar.bugReport')}
      </Button>

      <BugReport open={open} onClose={closeDialog} />
    </>
  )
}
